import React from "react";
import { BackgroundColourEnum, ContainerSpacingEnum, ContainerWidthEnum } from "utils";
import "./Container.scss";
import classNames from "classnames";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  containerWidth?: ContainerWidthEnum;
  containerSpacing?: ContainerSpacingEnum;
  backgroundColour?: BackgroundColourEnum;
  sectionId?: string;
}

/**
 * Returns a wrapper container for components
 *
 * @param children - The children to be wrapped inside the container
 * @param className - The classname to be applied to the section
 * @param containerWidth - The width of the container. "layout" | "layout--small" | "full-bleed"
 * @param containerSpacing - the margins for the section. "section" | "section--small" | "section--large"
 * @param backgroundColour - the background colour for the section, will add padding
 * @param sectionId - Sets an ID to the container, for linking to
 * @returns The children wrapped in a standard container
 *
 */
export const Container: React.FC<ContainerProps> = ({
  className = "section-container",
  children,
  containerWidth = "layout",
  containerSpacing = "section",
  backgroundColour = "none",
  sectionId,
  ...other
}): JSX.Element => {
  const classesSplit = className.split(" ");

  return (
    <section
      // long winded way of getting template literals into object literals.
      className={classNames({
        [`${className}`]: className,
        [`${containerWidth}`]: containerWidth,
        [`${containerSpacing}`]: containerSpacing,
        [`theme--${backgroundColour}`]: backgroundColour !== "none",
      })}
      id={sectionId ? sectionId : ""}
      {...other}
    >
      <div className={classesSplit.map((item) => `${item}__wrapper`).join(" ")}>{children}</div>
    </section>
  );
};
